import Auth from '../auth/Auth';
import TripChangeInfo from '../models/TripChangeInfo';
import { WebClient } from './WebClient'

class ApiTripChange extends WebClient {
    async getTripChangeInfo(): Promise<TripChangeInfo | undefined> {
        const url = "/document/tripchange";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || undefined;
            }
            return undefined;
        }).catch(() => { return undefined; });
    }
}

export default new ApiTripChange();
